import assign from 'lodash/assign'
import { AnyAction } from 'redux'

import { PAGE } from '../constants'
import instrumentAction from '../instrumentAction'

function defaultProperties() {
    return {
        title: String(document.title),
        url: String(window.location),
        path: String(window.location.pathname),
        referrer: String(document.referrer),
    }
}

export type TrackPagePayload = {
    name?: string
    properties: ReturnType<typeof defaultProperties> & Partial<Location>
}

// https://segment.com/docs/libraries/analytics.js/#page
export function trackPage(
    action: AnyAction,
    pageName?: string,
    properties?: Partial<TrackPagePayload['properties']>,
) {
    const payload: TrackPagePayload = {
        name: pageName,
        properties: assign(defaultProperties(), properties),
    }

    return instrumentAction(action, PAGE, payload)
}
